import { Injectable, EventEmitter } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/map';

@Injectable()
export class Authentication {
  user: Object;
  userUpdated: EventEmitter<Object> = new EventEmitter();

  constructor(public http: Http,
              private router: Router,
              private route: ActivatedRoute) {}

  signUp(params: any) {
    return this.http.post(`${API_URL}/clients`, params).map(res => {
      return res.json();
    });
  }

  signIn(params: any) {
    return this.http.post(`${API_URL}/clients/sign_in`, params).map(res => {
      return res.json();
    });
  }

  updateClient(params: any) {
    return this.http.patch(`${API_URL}/clients`, params).map(res => {
      return res.json();
    });
  }

  updatePassword(params: any) {
    return this.http.patch(`${API_URL}/clients/update_password`, params).map(res => {
      return res.json();
    });
  }

  forgotPassword(email: string) {
    let params = { email: email}
    return this.http.get(`${API_URL}/clients/forgot_password`, { search: params }).map(res => {
      return res.json();
    })
  }

  setUser(user: Object) {
    this.user = user;
    window.localStorage.setItem('currentUser', JSON.stringify(user));
    this.userUpdated.emit(this.user);
    if(this.router.url == '/signup') {
      this.router.navigate(['./']);
    }
  }

  logOut() {
    window.localStorage.removeItem('currentUser');
    this.userUpdated.emit(null);
    this.router.navigate(['./']);
  }

  facebookAuth(access_token: string) {
    let params = { access_token: access_token }
    return this.http.post(`${API_URL}/api/v1/authentications/facebooks`, params).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/authentication.ts